import { BillingTier } from "../../__generated__/gql/graphql";
import { billingTierLabel } from "../../util/billing";
import Truncate from "../../ui/Truncate/Truncate";
import styles from "./TeamCard.module.scss";
import classNames from "classnames";

function TeamCard({
  name,
  billingTier,
  memberCount,
  className,
}: {
  name: string;
  billingTier: BillingTier;
  memberCount: number;
  className?: string;
}) {
  return (
    <div className={classNames(styles.container, className)}>
      <div className={styles.initial}>{name.charAt(0).toUpperCase()}</div>
      <div className={styles.details}>
        <Truncate className={styles.name}>{name}</Truncate>
        <div className={styles.stats}>
          <span>{billingTierLabel[billingTier]}</span>
          <span> · </span>
          <span>
            {`${memberCount} ${memberCount === 1 ? "member" : "members"}`}
          </span>
        </div>
      </div>
    </div>
  );
}

export default TeamCard;
